
(function () {
  'use strict';

  var observer = null;
  var timer = null;
  var scheduled = false;

  function buildAccordions(root) {
    root.querySelectorAll(
      'tr.fields > td > .field[id^="dynamic_option_id_"]'
    ).forEach(function (field, index) {
      if (field.querySelector(':scope > .oaf-option-accordion')) return;

      var label = field.querySelector(':scope > label');
      if (!label) return;

      var details = document.createElement('details');
      details.className = 'oaf-option-accordion';
      details.open = index === 0;

      var summary = document.createElement('summary');

      var title = document.createElement('span');
      title.className = 'oaf-option-title';
      title.textContent = label.textContent.trim() +
        (label.classList.contains('required') ? ' *' : '');

      var value = document.createElement('span');
      value.className = 'oaf-option-selection';

      summary.appendChild(title);
      summary.appendChild(value);
      details.appendChild(summary);

      var panel = document.createElement('div');
      panel.className = 'oaf-option-panel';

      Array.from(field.childNodes).forEach(function (node) {
        if (node !== label) panel.appendChild(node);
      });

      details.appendChild(panel);
      field.appendChild(details);
      label.classList.add('oaf-option-original-label');

      function update() {
        var selections = [];

        panel.querySelectorAll(
          'input:checked, select, input[type="text"], textarea'
        ).forEach(function (input) {
          if (input.disabled || input.closest('.ihidden')) return;

          var text = '';

          if (input.tagName === 'SELECT') {
            if (input.value && input.selectedIndex >= 0) {
              text = input.options[input.selectedIndex].textContent;
            }
          } else if (
            input.type === 'radio' ||
            input.type === 'checkbox'
          ) {
            var inputLabel = input.id
              ? panel.querySelector(
                  'label[for="' + CSS.escape(input.id) + '"]'
                )
              : null;

            text = inputLabel
              ? inputLabel.textContent
              : input.value;
          } else {
            text = input.value;
          }

          text = (text || '').replace(/\s+/g, ' ').trim();
          if (text) selections.push(text);
        });

        var selectionText = selections.join(', ');

        if (value.textContent !== selectionText) {
          value.textContent = selectionText;
          value.title = selectionText;
        }
      }

      var updateQueued = false;

      function scheduleUpdate() {
        if (updateQueued) return;

        updateQueued = true;

        requestAnimationFrame(function () {
          updateQueued = false;
          update();
        });
      }

      field.addEventListener('change', scheduleUpdate);
      field.addEventListener('input', scheduleUpdate);

      var errors = new MutationObserver(function () {
        scheduleUpdate();

        var error = panel.querySelector(
          '.validation-advice, .dpo-error, .validation-failed'
        );

        if (error && !error.closest('.ihidden')) {
          details.open = true;
        }
      });

      errors.observe(panel, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'disabled']
      });

      scheduleUpdate();
    });

    var form = root.closest('form');

    if (form && !form.dataset.oafAccordionValidation) {
      form.dataset.oafAccordionValidation = '1';

      function reveal() {
        root.querySelectorAll(
          '.oaf-option-accordion'
        ).forEach(function (details) {
          details.open = true;
        });
      }

      form.addEventListener('submit', reveal, true);

      form.addEventListener('click', function (event) {
        if (event.target.closest(
          '[type="submit"], [dpo_add2cart], ' +
          '.shopify-payment-button, .buy-now-container'
        )) {
          reveal();
        }
      }, true);
    }
  }

  function inlineOptions() {
    var slot = document.getElementById('oaf-dpo-inline-slot');
    var options = document.getElementById(
      'itoris_dynamicproductoptions'
    );

    if (
      !slot ||
      !options ||
      !options.querySelector('input,select,textarea')
    ) {
      return false;
    }

    var container =
      options.closest('.dpo-container') ||
      options.closest('#itoris_dynamicproductoptions_popup') ||
      options;

    if (!slot.contains(container)) {
      slot.appendChild(container);
    }

    container.classList.add('oaf-dpo-inline-container');

    buildAccordions(options);

    container.classList.remove('drawer-open');

    var button = document.getElementById('open-dpo-drawer');
    if (button) button.style.display = 'none';

    var overlay = document.getElementById('dpo-overlay');
    if (overlay) overlay.classList.remove('open');

    var mask = document.getElementById(
      'itoris_dynamicproductoptions_popup_mask'
    );
    if (mask) mask.style.display = 'none';

    document.body.classList.remove('dpo-drawer-open');

    return true;
  }

  function stop() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }

    if (timer) {
      clearTimeout(timer);
      timer = null;
    }

    scheduled = false;
  }

  function check() {
    scheduled = false;

    // Restore the inline position if Itoris moves
    // its options back into the original popup.
    var slot = document.getElementById('oaf-dpo-inline-slot');
    var options = document.getElementById(
      'itoris_dynamicproductoptions'
    );

    if (!slot || !options || !slot.contains(options)) {
      inlineOptions();
    }
  }

  function scheduleCheck() {
    if (scheduled) return;

    scheduled = true;
    requestAnimationFrame(check);
  }

  function start() {
    stop();

    if (!document.getElementById('oaf-dpo-inline-slot')) {
      return;
    }

    // Move options immediately if already available.
    inlineOptions();

    // Continue watching during initialization because
    // Itoris may reposition its container afterward.
    observer = new MutationObserver(function () {
      scheduleCheck();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Stop monitoring after the initialization period.
    timer = setTimeout(function () {
      stop();
    }, 30000);
  }

  function initialized() {
    scheduleCheck();
  }
  // Restore original Itoris tooltip icons in accordion headings.
  // Supports existing and future tooltip-enabled options.
  function restoreTooltipIcons() {
    var root = document.getElementById(
      'itoris_dynamicproductoptions'
    );
    if (!root) return;

    root.querySelectorAll(
      '.field[id^="dynamic_option_id_"]'
    ).forEach(function (field) {
      var title = field.querySelector(
        '.oaf-option-title'
      );

      var icon = field.querySelector(
        ':scope > label .dpo_tooltip_icon'
      );

      if (!title || !icon) return;

      title.appendChild(icon);
    });
  }

  // Run after the accordion and Itoris initialize.
  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(restoreTooltipIcons, 500);
  });

  window.addEventListener('dpo_initialized', function () {
    setTimeout(restoreTooltipIcons, 500);
  });

  // Check for late-loading Itoris tooltips.
  var tooltipChecks = 0;

  var tooltipTimer = setInterval(function () {
    restoreTooltipIcons();

    if (++tooltipChecks >= 20) {
      clearInterval(tooltipTimer);
    }
  }, 500);
  window.addEventListener('dpo_initialized', initialized);

  document.addEventListener(
    'shopify:section:load',
    start
  );

  if (window.jQuery) {
    window.jQuery(window).on(
      'dpo_initialized.oafInline',
      initialized
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
